import React, {Component} from 'react';

import moment from 'moment';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-ui-dist/jquery-ui.css';
import 'fullcalendar-scheduler';
import 'fullcalendar/dist/fullcalendar.min.css';
import 'fullcalendar-scheduler/dist/scheduler.min.css';
import {getAllUnScheduleAndScheduleWithDate,getScheduleById,insertOrUpdateSchedule} from '../../util/APIUtils';
import {SESSION_USER,APP_DATE_AND_TIME_FORAMT,DATE_FORAMT,TIME_FORMAT,BLANK_SPACE,API_BASE_URL} from '../../constants';
import JobScheduleForm from '../schedule/JobScheduleForm';



class JobCalendar extends Component {
  constructor(props) {
        super(props);
           this.state = {
            messageText:'',
            showMessage:false,
            selectedJobOption:'All'
        };

        this.handlePeopleChange = this.handlePeopleChange.bind(this);
        this.handleRouteChange = this.handleRouteChange.bind(this);
         this.handleEquipmentChange = this.handleEquipmentChange.bind(this);
         this.handleTeamChange = this.handleTeamChange.bind(this);
       this.handleLocationChange = this.handleLocationChange.bind(this);

       this.handleJobOptionChange= this.handleJobOptionChange.bind(this);
       this.addOrRemoveResourse=this.addOrRemoveResourse.bind(this);

  }

   



    componentDidMount() {
     let $this = this;
     localStorage.removeItem('eventFcId');
     var workingfromtime='08:00';
     var workingtotime='18:00';
     var defaultEventDuration='02:00';
     let user = JSON.parse(localStorage.getItem(SESSION_USER));
     if(user.setting){ 
         defaultEventDuration= user.setting.defaultEventDuration;
         workingfromtime= user.setting.fromtime;
         workingtotime= user.setting.totime;

     }
     var resourcesObject=this.props.resources;
     var peopleObjects=this.props.fields.peopleInfo;
    // var nowtime=this.props.nowdatetime;

      var cal= $('#calendar').fullCalendar({
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives', 
      titleFormat:"dddd, DD MMMM YYYY",
      defaultView: 'timelineDay',
        editable: false,
            nowIndicator: true,
            now: this.props.nowdatetime, // just for demo
            eventLimit: true,  
            scrollTime: this.props.currenttime,
        buttonText: {
               today:    'Today',
            },
            
           header: {
            left: 'prev,today,next',
            center: 'title',
            right: ''
          },
            businessHours: {
              start: workingfromtime, // a start time (10am in this example)
              end: workingtotime // an end time (6pm in this example)
            },
      resourceAreaWidth:'25%',
      resourceLabelText:'Jobs',
      resources:resourcesObject,
      events: this.props.schedules,
      eventConstraint: "businessHours",
       defaultTimedEventDuration:defaultEventDuration,
      resourceRender: function(resourceObj, th) {
                  var className='scheduletype_';
                 
                  if(typeof resourceObj.type != 'undefined'){
                      className=className+resourceObj.type;
                  }

                   if(th.find("span.fc-cell-text").length == 0){
                       th.find("span.fc-cell-text").prepend('<i class="fa fa-circle '+className+'"></i>&nbsp;&nbsp;&nbsp;');
                   }
                   else{
                        th.find("span.fc-cell-text").prepend('<i class="fa fa-circle '+className+'"></i>&nbsp;&nbsp;&nbsp;');
                   }
                   th.find("span.fc-cell-text").append('<br/>&nbsp;&nbsp;&nbsp;&nbsp;<small> <i class="mdi mdi-av-timer"></i>&nbsp;&nbsp;'+resourceObj.estimatedHours+'&nbsp;Hours</small>');

                   if(resourceObj.type==0){
                   th.find("div.fc-cell-content").css('border-left', "5px solid #f59847");
               
                   }else{
                      th.find("div.fc-cell-content").css('border-left', "5px solid #56ceb4");

                   }
                   
                 



      }, eventRender: function(event,element) {
                //console.log("eventRender");
         
          	    var imageUrl='../static/assets/images/people.png';
          	    if(event.imageUrl){
					          imageUrl=API_BASE_URL+event.imageUrl;
          	    }
               var formatedName="<h2>"+element.find(".fc-title").text()+"</h2>";      
               element.find(".fc-title").addClass('peopleevent'); 
               element.find(".fc-title").prepend('<img src="'+imageUrl+'" style="border-radius:100%;" height="35px" width="35px" alt="user" class="profile-pic">&nbsp;&nbsp;');   
          
    }, droppable: true, 
        drop: function(date, jsEvent, ui, resourceId) {
        	    document.getElementById("jobscheduleform").reset();
               var start=date.format();
               var defaultDuration = moment.duration($('#calendar').fullCalendar('option', 'defaultTimedEventDuration'));
               var end = date.clone().add(defaultDuration); // on drop we only have date given to us
               var eventId=this.id;
               


                if(start){
                           var fromdate= moment(start).format(DATE_FORAMT);
                           var fromtime= moment(start).format(TIME_FORMAT);
                           $('#fromdate').val(fromdate);
                           $('#fromtime').val(fromtime);
                }

                if(end){
                           var todate= moment(end).format(DATE_FORAMT);
                           var totime= moment(end).format(TIME_FORMAT);
                           $('#todate').val(todate);
                           $('#totime').val(totime);
                }
                getScheduleById(resourceId)
				       .then(response => {
				          //console.log(response);
				          if(response){
				          	  $('#title').val(response.title);
				          	  $('#priority').val(response.priority);
				          	  $('#id').val(response.id);
                      $('#estimatedHours').val(response.estimatedHours);


                      

                              $('#address').val(response.address);
                              $('#description').val(response.description);
                      
                      if(response.equipment){
                         $('#equipment').val(response.equipment.id);
                      }
                   
                      if(response.team){
                          $('#team').val(response.team.id);
                      }

                       if(response.location){

                          $('#location').val(response.location.id);
                      }
                      
                      

                      /*if(response.people){
                           let people = {
                               value: response.people.id,
                               label: response.people.firstName+' '+response.people.lastName,
                           };
                           $('#selectedPeoples').val(JSON.stringify(people));
                      }*/

                            $('#status').val(response.status);

                           $("label.error").hide(); //hide error message jobscheduleform
				          	  showpopup($(this),eventId); //open popup 
				       }

				          
				       }).catch(error => {
                             alert("error in getScheduleById  function");
				       });

            
         
       },eventReceive: function (event) {
                       console.log(event);
                       localStorage.setItem('eventFcId',event._id);
                       
                       if(event.people){
                            if(peopleObjects){
                              for (var k in peopleObjects){
                                   var peopleInfo=peopleObjects[k];
                                   if(peopleInfo.id==event.people){
                                          let people = {
                                            value: event.people,
                                            label: peopleInfo.name,
                                          };
                                          $('#selectedPeoples').val(JSON.stringify(people));
                                   }
                              } 
                            }
                        }

                     
       },eventClick:function(info){
                  if(info.title=='Travel Time')return false;
                    if(info.id){
                      localStorage.setItem('eventFcId',info._id);
                      loadpopup(info.id);
                    }
       }
     }); 

       var modalConfirm = function(callback){


       		 $("#saveevent").off('click').click(function () {
		          var val =$('#jobscheduleform').valid();
		          if(val){
                          let user = JSON.parse(localStorage.getItem(SESSION_USER));
			              var fields={};
			              fields["userId"] = user.id;
			              fields['title']=$("#title").val();
			              fields['priority']=$("#priority").val();
			              fields['description']=$("#description").val();
			              fields['address']=$("#address").val();
			              fields['teamId']=$("#team").val();
			              fields['equipmentId']=$("#equipment").val();
                    fields['estimatedHours']=$("#estimatedHours").val();

			              var selectedPeoples = $('#selectedPeoples').val();
			              selectedPeoples = JSON.parse(selectedPeoples);
			              console.log('selectedPeoples', selectedPeoples);

			              fields['peopleId']=selectedPeoples.value;
			              fields['fromdate']=$("#fromdate").val();
			              fields['fromtime']=$("#fromtime").val();
			              fields['todate']=$("#todate").val();
			              fields['totime']=$("#totime").val();
			              fields['type']=1;// 0 means unschedule //1 means schedule

			              fields['status']=$("#status").val();
			              fields['moduleId']=$("#moduleId").val();
                    fields['locationId']=$("#location").val();

              fields['fieldServiceNumber']=$("#fieldServiceNumber").val();
              fields['fieldServiceZohoId']=$("#fieldServiceZohoId").val();
              fields['zohoAppointmentId']=$("#zohoAppointmentId").val();
              
      
			              fields['id']=$("#id").val();

			              var selectedSkill = $('#selectedSkill').val();
			              selectedSkill = JSON.parse(selectedSkill);

			              var skillarray=[];
			              if(selectedSkill){
			                for(var k in selectedSkill){
			                    var s=selectedSkill[k];
			                    skillarray.push(s.value);
			                }
			              }
			              
			             // skillarray.push(selectedSkill[0].value);
			              fields['skillId']=skillarray;
			              console.log(fields);
			            //  return false;
              insertOrUpdateSchedule(fields)
	           .then(response => { 
                   if(!response.success){//if its false so validation error server side
                     // alert(response.message)
                      $this.setState({showMessage:true,messageText:response.message});
                      return false;
                   }else{
                      $this.setState({showMessage:false,messageText:''});
                   }

			       //    var eventss=calendarObject.getEventById(1);
			           var eventFcId= localStorage.getItem('eventFcId');
                   //console.log("eventFcId----");
                 //console.log(eventFcId);
                 if(eventFcId){

                     localStorage.removeItem('eventFcId');
                
                     var eventObj = $("#calendar").fullCalendar('clientEvents',eventFcId)[0];
                     eventObj.title= selectedPeoples.label;

                     var startAsString=$("#fromdate").val()+BLANK_SPACE+$("#fromtime").val();
                     var fromDateObject= moment(startAsString,APP_DATE_AND_TIME_FORAMT);
                     var endAsString=$("#todate").val()+BLANK_SPACE+$("#totime").val();
                     var endDateObject= moment(endAsString,APP_DATE_AND_TIME_FORAMT);
                     
                     eventObj.resourceId=response.id;
                     eventObj.start=fromDateObject;
                     eventObj.end=endDateObject;
                     eventObj.id=response.id
                     getUpdateEventObject(eventObj,selectedPeoples.value,peopleObjects);
                     //console.log(resourcesObject);

                    $('#calendar').fullCalendar('updateEvent',eventObj);


                 }else{

                    var newEvent = new Object();
                    newEvent.title = selectedPeoples.label;
                    
                    
                     var startAsString=$("#fromdate").val()+BLANK_SPACE+$("#fromtime").val();
                     var fromDateObject= moment(startAsString,APP_DATE_AND_TIME_FORAMT);
                     var endAsString=$("#todate").val()+BLANK_SPACE+$("#totime").val();
                     var endDateObject= moment(endAsString,APP_DATE_AND_TIME_FORAMT);
                     
                     newEvent.resourceId=response.id;
                     newEvent.start=fromDateObject;
                     newEvent.end=endDateObject;
                     newEvent.id=response.id;
                   


                    $('#calendar').fullCalendar('renderEvent', newEvent);


                 }
                

			          callback(true);
		            $("#add-new-event").modal('hide');
		            document.getElementById("jobscheduleform").reset();
	          }).catch(error => {             
	                    alert('error');
	          })
		          }
           });


            $("#closeevent").off('click').click(function () {
              callback(false);
              $("#add-new-event").modal('hide');
              document.getElementById("jobscheduleform").reset();

            });

       };

        function loadpopup(eventId){
          
              let user = JSON.parse(localStorage.getItem(SESSION_USER));
               getScheduleById(eventId)
               .then(response => {
                  console.log(response);
                  if(response){
                      $('#id').val(response.id);
                      $('#title').val(response.title);
                      $('#priority').val(response.priority);
                      
                      $('#address').val(response.address);
                      $('#description').val(response.description);
                      
                      if(response.equipment){
                         $('#equipment').val(response.equipment.id);
                      }

                      if(response.location){
                          $('#location').val(response.location.id);
                      }

                      if(response.skillList){

                           let skillArray = [];
                           for(var k in response.skillList){
                                 var skill=response.skillList[k];
                                 //console.log('-------ss------------');
                                 //console.log(skill);
                               skillArray.push({
                                   value: skill.id,
                                   label: skill.name,
                               });
                                  //$('#skills').val(skill.id);
                                  // $('#skills').val(skill.id).trigger('change');
                               //$('#skills').select2().val(skill.id).trigger("change")
                           }
                           //console.log('skillArray', skillArray);
                          $('#selectedSkill').val(JSON.stringify(skillArray));
                          // this.setState({selectedSkill: skillArray});
                      }
                   
                      if(response.team){
                        //  $('#people').rules('remove');
                          $('#team').val(response.team.id);
                      }
                       if(response.people){
                         // $('#team').rules('remove');
                          let people = {
                              value: response.people.id,
                              label: response.people.firstName+' '+response.people.lastName,
                          };
                          $('#selectedPeoples').val(JSON.stringify(people));
                      }

                      if(response.fromDate){
                           var fromdate= moment(response.fromDate,APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                           var fromtime= moment(response.fromDate,APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                           $('#fromdate').val(fromdate);
                           $('#fromtime').val(fromtime);
                      }

                      if(response.toDate){
                           var todate= moment(response.toDate, APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                           var totime= moment(response.toDate, APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                           $('#todate').val(todate);
                           $('#totime').val(totime);
                      }


                    
                      if(response.status){
                        $('#status').val(response.status);
                      }

                      if(response.moduleId){
                        $('#moduleId').val(response.moduleId);
                      }

                     if(response.estimatedHours){
                        $('#estimatedHours').val(response.estimatedHours);
                      }
                      $('#fieldServiceNumber').val(response.fieldServiceNumber);
                      $('#fieldServiceZohoId').val(response.fieldServiceZohoId);
                      $('#zohoAppointmentId').val(response.zohoAppointmentId);
                

                      

                      $("label.error").hide(); //hide error message jobscheduleform
                      showpopup2(eventId); //open popup
                      /*setTimeout(function () {
                          $('#id').val(eventId);
                      },500);*/
                  }

                  
               }).catch(error => {
                        alert("error in getScheduleById  function");
               });
        

      }

       function getUpdateEventObject(event,id,peopleObjects){
               if(id){
               	   for(var k in peopleObjects){
               	   	  var people=peopleObjects[k];
               	   	  if(people.id==id){
               	   	  	   if(people.profileLogo){
               	   	  	   	  event.imageUrl='/image/people/'+id+'/profileimage.jpg';
               	   	  	   }else{
               	   	  	   	  return '';
               	   	  	   }
               	   	  	   if(people.bgcolor){
                               event.backgroundColor=people.bgcolor;
                               event.borderColor=people.bgcolor;
               	   	  	   }else{
                               event.backgroundColor='#54555e';
                               event.borderColor='#54555e';
               	   	  	   }
               	   	  	   if(people.textColor){
               	   	  	   	   event.color=people.textColor;
               	   	  	   }else{
               	   	  	      event.backgroundColor='#e5e7f5';
               	   	  	   }
               	   	  }
               	   }
               }

       }

         function showpopup2(eventId){
       $('#add-new-event').modal({
            backdrop: 'static',
            keyboard: false
          })

       var result= modalConfirm(function(confirm){
        if(confirm){
          return false;
        }else{ 
          return false;

        }
      });
       return false;


     }



      function showpopup(externalEventObject,eventId){
           $('#add-new-event').modal({
			      backdrop: 'static',
			      keyboard: false
			    })
       var result= modalConfirm(function(confirm){
        if(confirm){
         // externalEventObject.remove();
          return false;
        }else{
          var ids=[eventId];
          $('#calendar').fullCalendar('removeEvents',ids);
          return false;

        }
      });
       return false;
     }


               $('.fc-prev-button').click(function(){
	    		     var date = $('#calendar').fullCalendar('getDate');
                     date=moment(date).format('MM/DD/YYYY');
                     removeAllresourse(date,user.id,$this.state.selectedJobOption);
	    		     return false;
	    		});

	    		$('.fc-next-button').click(function(){
	    		     var date = $('#calendar').fullCalendar('getDate');
                     date=moment(date).format('MM/DD/YYYY');
                     removeAllresourse(date,user.id,$this.state.selectedJobOption);
	   		         return false;
	    		});
	    		
	    		
	    		$(".fc-today-button").click(function () {
	    		     var date = $('#calendar').fullCalendar('getDate');
                     date=moment(date).format('MM/DD/YYYY');
                     removeAllresourse(date,user.id,$this.state.selectedJobOption);    			  
	    		    return false;
	    		}); 

	    		function removeAllresourse(date,userId,filter){
                 
                // var fields=[];
                // fields['date']=date;
                // fields['userId']=userId;

                 getAllUnScheduleAndScheduleWithDate(date,userId,filter).then(response => {
                        console.log(response);
                        removeAllResouses();
                        if(response.resourceList){
                            for(var k in response.resourceList){
                            	var res=response.resourceList[k];
                            	$('#calendar').fullCalendar('addResource',res);									                            }
                            //$('#calendar').fullCalendar('resources',response.resourceList);
                        }
                        if(response.schedules){
                        	$('#calendar').fullCalendar('removeEvents');
		  					$('#calendar').fullCalendar('addEventSource', response.schedules);
                        }
                      
                }).catch(error => {
                      alert("error in getAllUnScheduleAndScheduleWithDate")
                });
	    			    
	    		}

	    		function removeAllResouses(){
	    			 var resources=$('#calendar').fullCalendar('getResources');
                         if(resources){
                              for(var k in resources){
                              	var res=resources[k];
                              	$('#calendar').fullCalendar('removeResource',res);
                              }
                         }
	    		}



  $('#date-daily').change(function () {
                     var selectedDate = $('#date-daily').val();
                    var view= $('#calendar').fullCalendar('getView');
                   // alert("The view's title is " + view.name);

                     $('#calendar').fullCalendar('changeView',view.name);
                     selectedDate = moment(selectedDate, "MM/DD/YYYY").format("MM/DD/YYYY"); 
                     $('#calendar').fullCalendar('gotoDate', selectedDate );
                     // removeAllresourse(selectedDate,)
                      removeAllresourse(selectedDate,user.id,$this.state.selectedJobOption);
             
                });
    }

     handleJobOptionChange(changeEvent){
         this.setState({
            selectedJobOption: changeEvent.target.value
         });
       
            let user = JSON.parse(localStorage.getItem(SESSION_USER));
            var date = $('#calendar').fullCalendar('getDate');
            date=moment(date).format('MM/DD/YYYY');
            this.addOrRemoveResourse(date,user.id,changeEvent.target.value);

    }

    addOrRemoveResourse(date,userId,filter){
       getAllUnScheduleAndScheduleWithDate(date,userId,filter).then(response => {
                       // console.log(response);
                         var resources=$('#calendar').fullCalendar('getResources');
                         if(resources){
                              for(var k in resources){
                                var res=resources[k];
                                $('#calendar').fullCalendar('removeResource',res);
                              }
                         }

                        if(response.resourceList){
                            for(var k in response.resourceList){
                              var res=response.resourceList[k];
                              $('#calendar').fullCalendar('addResource',res);                                             }
                            //$('#calendar').fullCalendar('resources',response.resourceList);
                        }
                        if(response.schedules){
                          $('#calendar').fullCalendar('removeEvents');
                $('#calendar').fullCalendar('addEventSource', response.schedules);
                        }
                      
                }).catch(error => {
                      alert("error in getAllUnScheduleAndScheduleWithDate")
                });
    }

    handlePeopleChange(){       
        window.location.href='/schedule';
    }

	  handleRouteChange(){
	     window.location.href='/schedule?view=agendaDay';
	  }

    handleEquipmentChange(){
       window.location.href='/equipmentview';
    }

     handleTeamChange(){
       window.location.href='/teamview';
   }

    handleLocationChange(){
       window.location.href='/locationview';
   }

   render(){
   return <div className="col-md-9">
            <div className="card">
                <div className="card-body">
   <div className="row1">
                  
                  <div style={{float:'left'}}>
                   
                    <div className="view-by-items-block">
                           <span  style={{cursor:'pointer'}} onClick={this.handleJobChange}  className="view-by-item">
                             <i className="icon-list active"></i><button style={{display:'none1'}} type="button" id="jobview" onClick={this.handleJobChange} className="active btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Job</button>
                            </span>

                            <span  style={{cursor:'pointer'}} onClick={this.handlePeopleChange}  className="view-by-item"  >
                             <i className="icon-user "></i><button type="button" id="peopleview" onClick={this.handlePeopleChange} className={this.props.calendarview=='agendaDay' ? 'btn waves-effect waves-light btn-outline-success btn-rounded btn-xs':' btn waves-effect waves-light btn-outline-success btn-rounded btn-xs'}>Employee</button>
                           </span>

                           <span  style={{cursor:'pointer'}} onClick={this.handleRouteChange}  className="view-by-item" style={{display:'none'}}>
                             <i className="icon-user "></i><button type="button" id="routeview" onClick={this.handleRouteChange} className={this.props.calendarview=='agendaDay' ? 'active btn waves-effect waves-light btn-outline-success btn-rounded btn-xs':'btn waves-effect waves-light btn-outline-success btn-rounded btn-xs'}>Route</button>
                           </span>

                           <span  style={{cursor:'pointer'}} onClick={this.handleEquipmentChange}  className="view-by-item">
                            <i className="icon-settings"></i><button type="button" id="equipmentview" onClick={this.handleEquipmentChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Equipment</button>
                           </span>

                           <span  style={{cursor:'pointer'}} onClick={this.handleTeamChange}  className="view-by-item">
                             <i className="icon-people"></i><button type="button" id="teamview" onClick={this.handleTeamChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Crew</button>
                         </span>

                         <span style={{cursor:'pointer'}} onClick={this.handleLocationChange} className="view-by-item">
                              <i className="icon-location-pin"></i><button type="button" id="locationview" onClick={this.handleLocationChange} className=" btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Location</button>
                        </span>
                    </div>
                   </div>


                        <div style={{float:'right'}}>&nbsp;&nbsp;&nbsp;&nbsp; <input type="text" id="date-daily" placeholder="Select the date"  style={{width:'115px',position:'relative',zIndex: '10',height:'24px',border:'1px solid grey',color:'#333',borderRadius:'3px'}} /></div> &nbsp;&nbsp;
                    
                                        <div className="btn-group" style={{float:'right'}}>
                                            <label className={this.state.selectedJobOption=='All'?'btn btn-primary btn-xs active':'btn btn-primary-job btn-xs'} id="all">
                                                <input type="radio" name="options" autoComplete="off" checked={true}  value="All" onChange={this.handleJobOptionChange} checked={this.state.selectedJobOption === 'All'}/> All
                                            </label>
                                            <label className={this.state.selectedJobOption=='Scheduled'?'btn btn-primary btn-xs active':'btn btn-primary-job btn-xs'} >
                                                <input type="radio" name="options"autoComplete="off" value="Scheduled" onChange={this.handleJobOptionChange} checked={this.state.selectedJobOption === 'Scheduled'}/> <i className="fa fa-circle scheduletype_1"></i> Scheduled
                                            </label>
                                            <label className={this.state.selectedJobOption=='Unscheduled'?'btn btn-primary btn-xs active':'btn btn-primary-job btn-xs'} >
                                                <input type="radio" name="options" autoComplete="off" value="Unscheduled" onChange={this.handleJobOptionChange} checked={this.state.selectedJobOption === 'Unscheduled'}/> <i className="fa fa-circle scheduletype_0"></i> Unscheduled
                                            </label>
                                        </div>
                
                 </div>
                  <div id="calendar" style={{clear:'both'}}></div>
                
                  <JobScheduleForm fields={this.props.fields} states={this.state}/>

              
                </div>
            </div>
        </div>;
  } 
}
export default JobCalendar;